import config from 'configAlias';
import { get } from 'lodash-es';

const LOG_OFF_URI = get(config, 'appConfig.apiEndpoint.logoffUrl', null);

export const redirectToLogOffUrl = () => {
  window.location.href = `${LOG_OFF_URI}`;
};
